export default function (Site, $) {
  Site.widget("mobileMenuButton", {
    _create() {
      this.element.click(() => {
        $(document.body).toggleClass("mobile-nav-active");
        $(window).resize();
      });
    },
  });

  Site.widget("mobileMenu", {
    _create() {
      this.contentArea = this.element.find(".menu-content");
      this.sections = this.element.find(".section ul");

      this.element.on("mousewheel wheel DOMwheel", (e) => {
        e.stopPropagation();
      });

      this.element.find(".section .section-title").each((k, el) => {
        $(el).parent(".section").data("sectionIndex", k);
        $(el).click(() => {
          if (this.currentSection === Number(k)) {
            this.expandSection(null);
          } else {
            this.expandSection(Number(k));
          }
        });
      });

      this.currentSection = null;

      $(window).resize(() => {
        this.reposition();
      });

      Site.on("xhrPageChanged", () => {
        this.updateHiglight();
      });

      this.updateActive(true);
    },
    updateActive(instant) {
      // const item = this.element.find(".section .section-title")
      this.element
        .find("[data-section-url]")
        .removeClass("expanded")
        .each((k, el) => {
          const data = $(el).data();
          if (data.sectionUrl.match(/^\/[a-z0-9\-\_]+/)) {
            if (window.location.href.indexOf(data.sectionUrl) > -1) {
              this.expandSection(data.sectionIndex, instant);
            }
          }
        });
      this.updateHiglight();
    },
    reposition(contentHeight, instant = false) {
      if (!contentHeight) {
        contentHeight = this.contentArea.height();
      }
    },
    updateHiglight() {
      this.element
        .find("a")
        .removeClass("active")
        .each((k, el) => {
          if (el.getAttribute("href") === window.location.pathname) {
            console.log("Highlighting item", el);
            $(el).addClass("active");
          }
        });
    },
    expandSection(sectionIndex, instant = false) {
      let currentHeight = this.contentArea.height();
      let nextSectionHeight = 0;
      let oldSectionHeight = 0;
      let oldSection, nextSection;
      this.sections.hide();
      if (typeof sectionIndex === "number") {
        nextSection = this.sections.eq(sectionIndex).show();
        nextSectionHeight = nextSection.height();
      }
      const newHeight = this.contentArea.height();
      this.sections.hide();
      if (typeof this.currentSection === "number") {
        oldSection = this.sections.eq(this.currentSection).show();
        oldSectionHeight = oldSection.height();
      }

      // Animate the old and new sections
      if (oldSection) {
        oldSection.parent("li:first").removeClass("expanded");
        oldSection
          .show()
          .css({
            height: oldSectionHeight,
          })
          .animate(
            {
              height: 0,
            },
            {
              duration: 500,
              complete: () => {
                oldSection.css("height", "").hide();
              },
            }
          );
        if (instant) oldSection.finish();
      }
      if (nextSection) {
        nextSection.parent("li:first").addClass("expanded");
        nextSection
          .show()
          .css({
            height: 0,
          })
          .animate(
            {
              height: nextSectionHeight,
            },
            {
              duration: 500,
              complete: () => {
                nextSection.css("height", "");
              },
            }
          );
        if (instant) nextSection.finish();
      }

      this.currentSection = sectionIndex;

      this.reposition(newHeight, instant);
      this.updateHiglight();
    },
  });
}
